import { useState, useMemo } from 'react';
import { buildDateFilter } from '../utils/documentUtils';

export const useDocumentFilters = () => {
  const [selectedYears, setSelectedYears] = useState<string[]>([]);
  const [selectedMonths, setSelectedMonths] = useState<string[]>([]);
  const [isYearFilterApplied, setIsYearFilterApplied] = useState(false);
  const [isMonthFilterApplied, setIsMonthFilterApplied] = useState(false);

  const isFiltering = isYearFilterApplied || isMonthFilterApplied;

  const createdAtRanges = useMemo(() => {
    if (!isFiltering) return null;
    const ranges = buildDateFilter(
      isYearFilterApplied ? selectedYears : [],
      isMonthFilterApplied ? selectedMonths : [],
    );
    return ranges.length ? ranges : null;
  }, [isYearFilterApplied, isMonthFilterApplied, selectedYears, selectedMonths, isFiltering]);

  const onApplyYear = () => setIsYearFilterApplied(true);
  const onClearYear = () => { setSelectedYears([]); setIsYearFilterApplied(false); };
  const onApplyMonth = () => setIsMonthFilterApplied(true);
  const onClearMonth = () => { setSelectedMonths([]); setIsMonthFilterApplied(false); };

  return {
    selectedYears,
    setSelectedYears,
    selectedMonths,
    setSelectedMonths,
    isYearFilterApplied,
    isMonthFilterApplied,
    isFiltering,
    createdAtRanges,
    onApplyYear,
    onClearYear,
    onApplyMonth,
    onClearMonth,
  };
};
